// src/pages/Login.js
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { login } from "../api/authApi"; // Import the login API function
import { useAuth } from "../context/AuthContext";
import Footer from "../components/Footer";
import { onLandFetchData } from "../services/onlandsite";

const Login = () => {
  const { login: setAuthToken } = useAuth();
  const navigate = useNavigate();

  const [mobile_number, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await login(mobile_number, password); // Call the login API
      if (response.token) {
        setAuthToken(response.token); // Set the auth token in context
        localStorage.setItem("authToken", response.token); // Optionally save token in localStorage
        await onLandFetchData(true);
        navigate("/dashboard"); // Redirect to dashboard on successful login
      } else {
        setError(response.error || "Login failed");
      }
    } catch (error) {
      console.log(error)
      setError("An error occurred. Please try again.");
    }
  };

  return (
    <div>
      <div className="min-h-screen bg-[#e81b2c] bg-gradient-to-r from-[#e81b2c] to-[#8e2790] shadow-md">
        <Footer />
        <div className="flex items-center justify-center">
          <div className="max-w-lg w-full text-white p-8 shadow-2xl border-1 rounded-lg">
            <h2 className="text-2xl font-semibold text-center">
              Bimari Distribution Ltd
            </h2>
            <h4 className="text-2xl text-center mb-6">Login</h4>
            {error && <div className="mb-4 text-red-500">{error}</div>}{" "}
            {/* Display error */}
            <form onSubmit={handleLogin}>
              <div className="mb-4">
                <label className="block text-gray-100">Mobile Number</label>
                <input
                  type="text"
                  className="w-full px-4 py-2 mt-2 border rounded-md"
                  value={mobile_number}
                  onChange={(e) => setMobileNumber(e.target.value)}
                  required
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-100">Password</label>
                <input
                  type="password"
                  className="w-full px-4 py-2 mt-2 border rounded-md"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <button
                type="submit"
                className="w-full bg-blue-500 text-white py-2 rounded-md hover:bg-blue-600"
              >
                Login
              </button>
              <div className="mt-2">
                Do not have account{" "}
                <Link to="/register" className="text-blue-500">
                  Register
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
